import { RoleFamily } from './companies'

export type WorkerPreferences = {
  id: string
  createdAt: Date
  updatedAt: Date
  workerId?: string
  ghostProfileId?: string
  hoursPerWeek?: number
  scheduleConsistency: ScheduleConsistencyOptions[]
  transportationMode?: TransportationOptions
  commuteDistanceUnit?: DistanceUnit
  commuteDistanceValue?: number
  minimumPayRate?: number
  maximumPayRate?: number
  payRateUnit?: PayRateUnit
  roleFamilies: RoleFamily[]
  type: PreferenceType
  schedulePreferences: WorkSchedulePreferenceSlot[]
  workerFacingSchedulePreferences: WorkerFacingSchedulePreferenceSlot[]
}

export enum PayRateUnit {
  HOURLY = 'HOURLY',
}

export enum PreferenceType {
  WORKER_REPORTED = 'WORKER_REPORTED',
  SYSTEM_CALCULATED = 'SYSTEM_CALCULATED',
}

export enum DistanceUnit {
  MILES = 'MILES',
  MINUTES = 'MINUTES',
}

export type PayRatePreference = {
  minimumPayRate: number
  maximumPayRate: number | undefined
  payRateUnit: PayRateUnit
}

export type CommutePreference = {
  transportationMode: TransportationOptions
  commuteDistanceUnit: DistanceUnit
  commuteDistanceValue: number
}

export enum DayOfWeek {
  SUN = 'SUN',
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
}

export enum ScheduleConsistencyOptions {
  CONSISTENT = 'CONSISTENT',
  TEMPORARY = 'TEMPORARY',
  ONE_OFF = 'ONE_OFF',
}

export enum TransportationOptions {
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  DRIVE_OWN_VEHICLE = 'DRIVE_OWN_VEHICLE',
  DRIVE_SHARED_VEHICLE = 'DRIVE_SHARED_VEHICLE',
  CARPOOL = 'CARPOOL',
  TAXI = 'TAXI',
  WALKING_BIKING_ETC = 'WALKING_BIKING_ETC',
}

export enum AvailabilityPeriod {
  EARLY_MORNING_APPROX_4AM_8AM = 'EARLY_MORNING_APPROX_4AM_8AM',
  MORNING_APPROX_8AM_12PM = 'MORNING_APPROX_8AM_12PM',
  AFTERNOON_APPROX_12PM_5PM = 'AFTERNOON_APPROX_12PM_5PM',
  EVENING_APPROX_5PM_10PM = 'EVENING_APPROX_5PM_10PM',
  OVERNIGHT_APPROX_10PM_4AM = 'OVERNIGHT_APPROX_10PM_4AM',
}

export type WorkSchedulePreferenceSlot = {
  createdAt: Date
  updatedAt: Date
  day: DayOfWeek
  period: AvailabilityPeriod
}

export type CreateWorkSchedulePreferenceSlot = Omit<
  WorkSchedulePreferenceSlot,
  'createdAt' | 'updatedAt'
>

export type WorkerFacingSchedulePreferenceSlot = {
  slotType: WorkerFacingSchedulePreferenceSlotType
  period: WorkerFacingSchedulePreferenceSlotPeriod
}

export enum WorkerFacingSchedulePreferenceSlotType {
  WEEKDAY = 'WEEKDAY',
  WEEKEND = 'WEEKEND',
}

export enum WorkerFacingSchedulePreferenceSlotPeriod {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
  OVERNIGHT = 'OVERNIGHT',
}
